<h3 class="m-0 mb-2 px-1 text-lg font-bold">{{ title }}</h3>

<app-card [noMargin]="true" [showHeader]="false">
    <div card-body class="ask-body">
        @for (prompt of prompts; track prompt) {
            <button type="button" class="ask-chip" (click)="ask(prompt)">
                {{ prompt }}
            </button>
        }
    </div>
</app-card>
